import React from 'react';

/**
 * FormLock: wraps form fields in a native <fieldset disabled={saving}>.
 *
 * When saving is true, the browser natively disables all descending
 * <input>, <select>, <textarea>, and <button> elements, preventing edits
 * and duplicate submissions while a request is in flight.
 *
 * Uses `className="contents border-0 p-0 m-0 min-w-0"` so it produces no box,
 * border, or padding, completely preserving the parent layout (flex/grid/block)
 * and RTL orientation.
 */
export default function FormLock({
  saving = false,
  disabled = false,
  className = 'contents',
  children,
  ...rest
}) {
  const isLocked = Boolean(saving || disabled);
  return (
    <fieldset
      disabled={isLocked}
      aria-busy={isLocked}
      className={`contents border-0 p-0 m-0 min-w-0 ${className}`}
      {...rest}
    >
      {children}
    </fieldset>
  );
}
